import { Components } from '@mui/material';

export const MuiRadio: Components['MuiRadio'] = {
  styleOverrides: {
    root: {
      '& .MuiSvgIcon-root': {
        fontSize: 16,
      },
      '&.Mui-checked .MuiSvgIcon-root:first-of-type': {
        color: '#CFD7E9',
      },
      '&.Mui-checked .MuiSvgIcon-root:last-of-type': {
        color: '#1C5BFE',
      },
      color: '#CFD7E9',
      height: 24,
      padding: 4,
      width: 24,
    },
  },
};
